import { Button } from 'antd'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Box from '../../components/AuthBox/AuthBox'
import { signupCode } from '../../redux/actions'

import styles from './Signin.module.scss'

function Singup() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  return (
    <div className={styles.container}>
      <Box
        title={location.state?.userType === 2 ? 'ثبت نام شرکت حمل و نقل و لجستیک' : 'ثبت نام صاحبان کالا'}
        description={location.state?.userType === 2 ? 'در صورتیکه شما یک شرکت حمل و نقل و لجستیک هستید از این بخش ثبت نام کنید' : 'در صورتیکه شما یک صاحب کالا هستید و درخواست جهت استعلام کرایه حمل دارید از این بخش ثبت نام کنید.'}
        actions={[
          {
            label: 'ارسال',
            onClick: (values) => {
              dispatch({
                type: 'signup',
                payload: {
                  loading: false,
                  number: values.number
                }
              })
              dispatch(signupCode(values.number, () => {
                history.push('/code', { type: 'signup', userType: location.state?.userType || 1 })
              }))
            },
            main: true,
            type: 'primary',
          }
        ]}
        form={[
          { 
            name: 'number',
            label: 'شماره همراه',
            type: 'number',
            rules: [
              { required: true, message: 'شماره همراه خود را وارد کنید!' },
              { pattern: /^09\d{9}$/, message: 'شماره همراه صحیح نیست!' },
            ],
          }
        ]}
        footer={(
          <div>
            <span>در صورتیکه در سامانه عضو هستید</span>
            <Button type='link' onClick={() => {
              history.push('signin', { userType: location.state?.userType || 1 })
            }}>ورود</Button>
            <span>کنید.</span>
          </div>
        )}
        loading={false}
      >
      </Box>
    </div>
  )
}

export default Singup
